import axios from "axios";

export const getDisplayBannerRequest = async (): Promise<any[]> => {
  try {
    const { data, status } = await axios.get<any[]>(
      `/api/v1/display_banners`
    );
    return data;
  } catch (err) {
    return [];
  }
};
